import React, { useState } from "react"; // Added useState
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"; // Added Navigate
import Login from "./pages/Login";
import Users from "./pages/Users";
import UserDetails from "./pages/UserDetails";
import Dashboard from "./pages/Dashboard";
import Layout from "./layout/Layout";
import Assessment from "./pages/Assessment";

function App() {
  const [isAuth, setIsAuth] = useState(!!localStorage.getItem("token"));
  const [page, setPage] = useState("dashboard");
  const [viewId, setViewId] = useState(null);

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuth(false);
  };

  // Separate AdminApp logic to keep the routing table clean
  const AdminApp = () => {
    if (!isAuth) return <Navigate to="/" />;

    let content;
    if (viewId) {
      content = <UserDetails id={viewId} onBack={() => setViewId(null)} />;
    } else if (page === "users") {
      content = <Users onView={(id) => setViewId(id)} />;
    } else {
      content = <Dashboard />;
    }

    return (
      <Layout setPage={setPage} onLogout={logout}>
        {content}
      </Layout>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTE */}
        <Route path="/LiverHealth" element={<Assessment />} />

        {/* LOGIN: Redirect to admin if already authenticated */}
        <Route
          path="/"
          element={
            isAuth ? <Navigate to="/admin" /> : <Login onLogin={() => setIsAuth(true)} />
          }
        />

        {/* PROTECTED ADMIN ROUTE */}
        <Route path="/admin" element={<AdminApp />} />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;